// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__3rjmg","content":"RecentSearches_content__9HpRB"};